// extracted by mini-css-extract-plugin
module.exports = {"premiumCamLabel":"PremiumCamLabel_premiumCamLabel__PBUZD","premiumCamLabelInner":"PremiumCamLabel_premiumCamLabelInner__cvedc"};